import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePrivateCompanyLeadSpecialFeeProps {
  privateCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useDeletePrivateCompanyLeadSpecialFee = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePrivateCompanyLeadSpecialFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePrivateCompanyLeadSpecialFee'],
    mutationFn: async (id: string) => {
      const private_company_lead = {
        fee_rule_attributes: {
          special_entries_attributes: [
            {
              id,
              _destroy: true,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
